import type { AreaDef, WorkspaceSpec } from "../types/domain";

export interface InstitutionLocation {
  areaId: string;
  pageId: string;
}

export function resolveInstitutionLocation(
  areas: AreaDef[],
  pages: Record<string, WorkspaceSpec>,
  fallback: InstitutionLocation,
): InstitutionLocation {
  if (typeof window === "undefined") return fallback;
  const [areaId, pageId] = window.location.hash.replace(/^#\/?/, "").split("/");
  const area = areas.find(candidate => candidate.id === areaId);
  const route = area?.routes.find(candidate => candidate.id === pageId);
  return area && route && pages[route.id] ? { areaId: area.id, pageId: route.id } : fallback;
}

export function writeInstitutionLocation(location: InstitutionLocation) {
  const nextHash = `#/${location.areaId}/${location.pageId}`;
  if (window.location.hash !== nextHash) window.history.pushState(null, "", nextHash);
}
